// extracted by mini-css-extract-plugin
export default {"header":"style_header__kiRRs","title":"style_title__aj-nO","deleteButton":"style_deleteButton__jKoZd"};